export default {
    traceability: {
        traceability: "traceability",
        traceabilityManagement: "Traceability Management",
        coffeeTraceabilityMngmnt: "Coffee Traceability Management",
        traceabilityPage: "Traceability Page",
        labelDesigner: "Label Designer",
        additionalInformation: "Additional Information",
        coffeeInformation: "Coffee Information",
        info1:
          "Provide information about the additional logos of your product. This information will be available to public on the coffee traceability page.",
        cropsinfo1:
          "Provide information about the additional logos of your product. This information will be available to public on the traceability page.",
        addSlogan: "Add Slogan",
        sloganToolTip:
          "Add a slogan to your product. This information will be available to public on the traceability page.",
        additionalLogos: "Additional Logos",
        title: "Title",
        sloganHint: "Slogan must be of 60 characters",
        sloganLengthError: "Slogan Length Too Long",
        description: "Description",
        mapLink: "Map Link",
        mapLinkTooltip: "Provide a map link to your product.",
        originCountryTitle: "Originating Country Name",
        enterOriginCountryTitle: "Enter Originating Country Name",
        enterCountryDescription:
          "Provide something interesting information about the country of origin",
        originatingCountryTooltip:
          "Provide information about the originating country of your product.",
        corporativeTitle: "Corporative Name",
        enterCorporativeTitle: "Enter Corporative Name",
        introDescription:
          "Additional details might include Production information, Supply Chain Intermediaries, Transportation Details, Storage Conditions, Processing, Regulatory Compliance, etc",
        corporativeTooltip: "Provide information about the cooperative.",
        coperativeDescriptionTooltip:
          "Provide information about the cooperative your farm is associated with.",
        websiteLink: "Website Link",
        addMedia: "Add Media",
        uploadImageVideo: "Upload Image/Video",
        uploadImage: "Upload Image",
        origin: "Origin",
        originationCountry: "Origination Country",
        info2:
          "Provide information about the originating country of your product. This information will be available to public on the coffee traceability page.",
        cropsinfo2:
          "Provide information about the originating country of your product. This information will be available to public on the traceability page.",
        countryImage: "Country Image",
        traceabilityImage: "Traceability Image",
        institutionalInfo: "Cooperative Information",
        info3:
          "If your farm is part of a cooperative, please provide the information about the cooperative.",
        cooperativeLogo: "Cooperative Logo",
        traceabilityIntro: "Traceability Introduction",
        info4:
          "Provide more information about the tracking and tracing of your product throughout its entire supply chain—from production or origin to the end consumer.",
        addLabel: "Add Label",
        chooseTitle: "Choose Title",
        chooseLabelDesign: "Choose Label Design Template",
        uploadYourLogo: "Upload Your Logo",
        info5:
          "Instructions: Image size should be at least 1000 x 1000 pixels square. You can choose Transparent PNG to sync with the background colors.",
        chooseTemplateColors: "Choose template colors",
        backgroundColor: "Background Color",
        foregroundColor: "Foreground Color",
        labelStatus: "Label Status",
        inactive: "Inactive",
        download: "Download",
        enterLabelTitle: "Enter Label Title",
        enableLogoProcessing: "Enable Logo Processing",
      },
      cacaoTraceability: {
        traceability: "traceability",
        cacaoTraceabilityMngmnt: "Cacao Traceability Management",
        traceabilityPage: "Traceability Page",
        labelDesigner: "Label Designer",
        additionalInformation: "Additional Information",
        info1:
          "Provide information about the additional logos of your product. This information will be available to public on the cacao traceability page.",
        addSlogan: "Add Slogan",
        additionalLogos: "Additional Logos",
        title: "Title",
        description: "Description",
        mapLink: "Map Link",
        websiteLink: "Website Link",
        addMedia: "Add Media",
        uploadImageVideo: "Upload Image/Video",
        origin: "Origin",
        info2:
          "Provide information about the originating country of your product. This information will be available to public on the cacao traceability page.",
        countryImage: "Country Image",
        institutionalInfo: "Institutional Information",
        info3:
          "Provide information about your company/cooperative, tell consumers about the relevant work you've been doing. This information will be available to the public on the cacao traceability page.",
        cooperativeLogo: "Cooperative Logo",
        traceabilityIntro: "Traceability Introduction",
        info4:
          "This section will give the consumer access to the entire coffee production and processing history. Describe the importance of traceability to your company/cooperative and to the world.",
        addLabel: "Add Label",
        chooseTitle: "Choose Title",
        chooseLabelDesign: "Choose Label Design Template",
        uploadYourLogo: "Upload Your Logo",
        info5:
          "Instructions: Image size should be at least 1000 x 1000 pixels square. You can choose Transparent PNG to sync with the background colors.",
        chooseTemplateColors: "Choose template colors",
        backgroundColor: "Background Color",
        foregroundColor: "Foreground Color",
        labelStatus: "Label Status",
        inactive: "Inactive",
        download: "Download",
        enterLabelTitle: "Enter Label Title",
    
        originTitle: "Origin Title",
        corporativeTile: "Corporative Title",
        enterSlogan: "Enter Slogan",
        enterTitle: "Enter Title",
        enterDescription: "Enter Description",
        enterMapLink: "Enter Map Link",
        enterWebsiteLink: "Enter Website Link",
      },
}